import axiosInstance from '../config/axiosConfig';

export const fetchBanners = async ({ app, estado }) => {
  const params = { app, estado };
  return await axiosInstance.get('parameter/get-banners', { params });
};

export const fetchSedes = async ({ app, estado }) => {
  const params = { estado, app };
  return await axiosInstance.get('parameter/get-sedes');
};

export const fetchDepartamentos = async () => {
  return await axiosInstance.get('parameter/lista-departamentos');
};

export const fetchOpcionesMenu = async ({ App, Publica, Tipo }) => {
  const params = { App, Publica, Tipo };
  return await axiosInstance.get('parameter/opciones-menu', { params });
};

export const fetchTiposIdentificacion = async () => {
  return await axiosInstance.get('parameter/tiposIdentificacion');
};

export const fetchOpcionesAdmin = async ({ publica, activa, tipo }) => {
  const params = { publica, activa, tipo };
  return await axiosInstance.get('parameter/opciones-admin', { params });
};

export const fetchListaConfiguracion = async ({ key }) => {
  const params = { key, app: true };
  return await axiosInstance.get('parameter/listar-configuracion', { params });
};

export const contactenos = async (body) => {
  return await axiosInstance.post('parameter/contactenos', body);
};

export const fetchTemas = async () => {
  return await axiosInstance.get('parameter/get-temas');
};

export const fetchPoliticas = async () => {
  return await axiosInstance.get('parameter/get-tyc');
};

export const fetchContent = async (tipo) => {
  const params = { tipo };
  return await axiosInstance.get('parameter/content', { params });
};
